import { render, staticRenderFns } from "./RecycleCard.vue?vue&type=template&id=8f2305d8&scoped=true"
import script from "./RecycleCard.vue?vue&type=script&lang=ts"
export * from "./RecycleCard.vue?vue&type=script&lang=ts"
import style0 from "./RecycleCard.vue?vue&type=style&index=0&id=8f2305d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2305d8",
  null
  
)

export default component.exports